module.exports = __webpack_public_path__ + "static/img/5740_phase_function_Paper_PointsHejduk_Prediction.639342d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5740_phase_function_Paper_PointsHejduk_Prediction.png
// module id = MqQ7
// module chunks = 0